import { CredoService, CredoError } from '@/services/credo.service';

const state = {
  payment: null,
  loading: false,
  serverResponse: null,
};

const getters = {
  payment: (state) => {
    return state.payment;
  },
};

const actions = {
  async initiatePayment({ commit }, data) {
    commit('startRequest');
    try {
      const response = await CredoService.initiatePayment(data);
      commit('paymentSuccess', response);
      commit('stopRequest');
      return response;
    } catch (e) {
      commit('stopRequest');
      if (e instanceof CredoError) {
        commit('dataError', {
          status: e.errorCode,
          message: e.message,
        });
      }
    }
  },
};

const mutations = {
  startRequest(state) {
    state.loading = true;
  },
  stopRequest(state) {
    state.loading = false;
  },
  dataError(state, response) {
    state.serverResponse = response;
  },
  paymentSuccess(state, response) {
    state.payment = response;
  },
};

export const credo = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
